import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetArrangedRows = () => {
  const [loading, setLoading] = useState(true);
  const [arrangedRows, setArrangedRows] = useState([]);

  const { enqueueSnackbar } = useSnackbar();

  const getArrangedRows = ({ guid, productPackGuid } = {}) => {
    setLoading(true);

    axiosClient
      .get('Inventory/ProductData/GetArranged', {
        params: { Guid: guid, ProductPackGuid: productPackGuid },
      })
      .then(res => {
        if (res.status === 200) {
          setArrangedRows(prev => {
            return res.data?.value;
          });
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return { getArrangedRows, loading, arrangedRows, setArrangedRows };
};

export default useGetArrangedRows;
